
import { RevPicker } from '@ds/components/Picker'

import ColorRound from '../../../Pickers/components/Picker/ColorRound'
import PickerRound from '../PickerRound'

export default {
  components: {
    RevPicker,
  },
  props: {
    step: {
      type: Object,
      required: true,
    },
    option: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  watch: {
    // Each time we click on a picker, the URL changes, thus we make some network call. Watching this prop
    // is an easy workaround to know the call is done and that the loading is over. We're triggering the "changed"
    // event after to scroll to the next question only when it's loaded
    option() {
      if (this.loading) {
        this.$emit('changed', this.option, this.step)
        this.loading = false
      }
    },
  },
  methods: {
    icon: (option) => {
      if (option.color) {
        return ColorRound
      }

      return PickerRound
    },
    iconProps: (option, index) => {
      if (option.color) {
        return { color: option.color, class: { 'flex-shrink-0': true } }
      }

      return {
        index,
        selected: option.selected,
        class: { 'flex-shrink-0': true },
      }
    },
    onClick() {
      if (!this.option.available) {
        return
      }

      this.$emit('click', this.option, this.step)

      // If the field is already selected, we won't change the URL nor refresh the network calls, so
      // let's directly trigger the changed event and skip the loading state
      if (this.option.selected) {
        this.$emit('changed', this.option, this.step)
      } else {
        this.loading = true
      }
    },
  },
}
